import React, { FC } from 'react';

import { defineMessages, useIntl } from 'react-intl';
import styled from 'styled-components';

import ActionButton from 'components/action-button';
import AccountLayout from 'components/layout/account';
import SanityBlockRenderer from 'components/sanity-block-renderer';

import theme from './theme';
import { IAccountRequestInfoViewProps } from './types';

const ButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 32px auto;
  width: 90%;

  ${Styles.desktop`
    width: 320px;
  `}
`;

const MessageWrapper = styled.div`
  margin-top: 32px;
  text-align: center;
  & p {
    display: inline;
    color: ${theme.messageColor};
  }
  & p:first-child {
    font-family: ${theme.messageHeadingFontFamily};
    font-weight: ${theme.messageHeadingFontWeight};
    text-transform: ${theme.messageHeadingTextTransform};
  }

  ${Styles.desktop`
    width: 332px;
  `}
`;

const Error = styled.p`
  color: ${Styles.color.error};
`;

export const AccountRequestInfoView: FC<IAccountRequestInfoViewProps> = ({
  headerText,
  content,
  confirmButtonText,
  errorText,
  email,
  onConfirm,
  requestMyInfoResult,
}) => {
  const { formatMessage } = useIntl();
  const confirmMessageText = formatMessage(messages.willSendYourRequestedInfoTo, {
    email,
  });

  return (
    <AccountLayout header={headerText}>
      <SanityBlockRenderer content={content}></SanityBlockRenderer>
      <ButtonContainer>
        <ActionButton data-testid="confirm-request-info-button" onClick={onConfirm}>
          {confirmButtonText}
        </ActionButton>
        {requestMyInfoResult.data?.requestMyInfo && (
          <MessageWrapper data-testid="confirmation-message">
            <p>{formatMessage(messages.thankYou)}</p>
            <br />
            <p>{confirmMessageText}</p>
          </MessageWrapper>
        )}
        {requestMyInfoResult.error && (
          <Error data-testid="request-my-info-error-message">{errorText}</Error>
        )}
      </ButtonContainer>
    </AccountLayout>
  );
};

export default AccountRequestInfoView;
const messages = defineMessages({
  thankYou: {
    id: 'thankYou',
    defaultMessage: 'Thank you!',
    description: 'Text alert',
  },

  willSendYourRequestedInfoTo: {
    id: 'willSendYourRequestedInfoTo',
    defaultMessage:
      'We will send your requested information to {email}. It will take about a week for this process to be complete.',
    description: 'Text instructions letting them know we are sending their information',
  },
});
